<template>
  <v-list>
    <v-list-item
      v-for="attendancePlace in attendancePlaces"
      :key="attendancePlace.id"
      link
      :to="`${basePath}/${attendancePlace.id}`"
    >
      <v-list-item-title class="px-6">
        {{ attendancePlace.name }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "DefaultLayoutAttendancePlaceList",
  props: {
    attendancePlaces: {
      type: Array,
      required: true,
    },
    basePath: {
      type: String,
      required: true,
    },
  },
};
</script>

<style></style>
